import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
const FoodMenuFilter = ({ holes, handleOnSelectHoles, parentIndex }) => {
  const { t } = useTranslation();
  return (
    <table>
      <tr>
        <th>{t("Prompt")}</th>
        <th>{t("Accept")}</th>
      </tr>
      <tr>
        <td>
          <div className="hole-wrapper">
            <div className="btn-wrapper">
              <Tooltip title={t("All")}>
                <button
                  onClick={() =>
                    handleOnSelectHoles(parentIndex, "allPrompt", null, true)
                  }
                  className="all-none-button"
                >
                  {t("All")}
                </button>
              </Tooltip>{" "}
              |{" "}
              <Tooltip title={t("None")}>
                <button
                  onClick={() =>
                    handleOnSelectHoles(parentIndex, "allPrompt", null, false)
                  }
                  className="all-none-button"
                >
                  {t("None")}
                </button>
              </Tooltip>
            </div>

            <div className="hole-btn">
              {holes.length > 0 ? (
                holes.map((v, i) => (
                  <button
                    key={`prompt_${v.HoleNumber}_${i}`}
                    onClick={() =>
                      handleOnSelectHoles(parentIndex, "prompt", i)
                    }
                    className={v.CanAdvertise && "active"}
                  >
                    {v.HoleNumber}
                  </button>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </td>
        <td>
          <div>
            <div className="btn-wrapper">
              <button
                onClick={() =>
                  handleOnSelectHoles(parentIndex, "allAccept", null, true)
                }
                className="all-none-button"
              >
                {t("All")}
              </button>{" "}
              |{" "}
              <button
                onClick={() =>
                  handleOnSelectHoles(parentIndex, "allAccept", null, false)
                }
                className="all-none-button"
              >
                {t("None")}
              </button>
            </div>
            <div className="hole-btn">
              {holes.length > 0 ? (
                holes.map((v, i) => (
                  <button
                    key={`accept_${v.HoleNumber}_${i}`}
                    onClick={() =>
                      handleOnSelectHoles(parentIndex, "accept", i)
                    }
                    className={v.CanOrderItems && "active"}
                  >
                    {v.HoleNumber}
                  </button>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </td>
      </tr>
    </table>
  );
};

export default FoodMenuFilter;
